import type { IndustryTemplate } from './base-template';
import { schweizerKmuTemplate } from './schweizer-kmu';
import { treuhandTemplate } from './treuhand';
import { treuhandKmuTemplate } from './treuhand-kmu';
import { treuhandStartupTemplate } from './treuhand-startup';
import { treuhandPrivateTemplate } from './treuhand-private';
import { anwaltTemplate } from './anwalt';
import { handwerkerTemplate } from './handwerker';
import { arztTemplate } from './arzt';
import { restaurantTemplate } from './restaurant';
import { immobilienTemplate } from './immobilien';
import { coiffeurTemplate } from './coiffeur';
import { itTemplate } from './it';
import { architekturTemplate } from './architektur';
import { finanzberatungTemplate } from './finanzberatung';
import { consultingTemplate } from './consulting';
import { fitnessTemplate } from './fitness';
import { eventsTemplate } from './events';
import { coachingTemplate } from './coaching';
import { zahnarztTemplate } from './zahnarzt';
import { reinigungTemplate } from './reinigung';
import { fotografieTemplate } from './fotografie';

export const industryTemplates: Record<string, IndustryTemplate> = {
  schweizer_kmu: schweizerKmuTemplate,
  treuhand: treuhandTemplate,
  treuhand_kmu: treuhandKmuTemplate,
  treuhand_startup: treuhandStartupTemplate,
  treuhand_private: treuhandPrivateTemplate,
  anwalt: anwaltTemplate,
  handwerker: handwerkerTemplate,
  arzt: arztTemplate,
  restaurant: restaurantTemplate,
  immobilien: immobilienTemplate,
  coiffeur: coiffeurTemplate,
  it: itTemplate,
  architektur: architekturTemplate,
  finanzberatung: finanzberatungTemplate,
  consulting: consultingTemplate,
  fitness: fitnessTemplate,
  events: eventsTemplate,
  coaching: coachingTemplate,
  zahnarzt: zahnarztTemplate,
  reinigung: reinigungTemplate,
  fotografie: fotografieTemplate,
};

export { mergeTemplate, baseTemplate } from './base-template';
export type { IndustryTemplate, TemplateOverrides } from './base-template';
